import { SpyneTrait } from "spyne";
import { BlogView } from "components/cards/blog-view";

export class BlogTraits extends SpyneTrait {
  constructor(context) {
    let traitPrefix = "blog$";
    super(context, traitPrefix);
  }

  static blog$OnRendered(props = this.props) {}

  static blog$SetScrollLock(lockScroll = true) {
    //lockScroll ? SpyneApp.pluginsFn.enableScrollLock() : SpyneApp.pluginsFn.disableScrollLock();
  }

  static blog$CheckToAddBlogItems(props = this.props) {
    this.blog$SetScrollLock(false);
    const { pageId } = props.data;
    const addBlogItem = (data) => {
      data["pageId"] = pageId;
      this.appendView(new BlogView({ data }), ".app-page-subnav-container");
    };
    if (props.data.content) {
      props.data.content.forEach(addBlogItem);
    }
  }
}
